import { makeStyles } from "@material-ui/core/styles";

export const startJourneyStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: "#17295B",
    padding: "20px 0px 20px 0px",
    borderRadius: "8px",
    position: "relative",
  },
  title: {
    fontWeight: 600,
    color: "#B3CFE2",
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.typography.pxToRem(17),
  },
  courseName: {
    color: "#FFFFFF",
    fontFamily: "Lato",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(34),
    lineHeight: theme.typography.pxToRem(41),
  },
  imageContainer: {
    display: "flex",
    justifyContent: "center",
    margin: "30px 0px 20px 0px",
  },
  moduleName: {
    color: "#ACEDFF",
    fontFamily: "Lato",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(10),
    lineHeight: theme.typography.pxToRem(14),
  },
  modulesContainer: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
  },
  moduleDetails: {
    cursor: "pointer",
    zIndex: 1,
  },
  inProgress: {
    color: "#F47B53",
  },
  isCompleted: {
    color: "#4EE1C9",
  },
  imageModuleContainer: {
    display: "flex",
    justifyContent: "center",
  },
  dashedLine: {
    borderWidth: "2px",
    borderStyle: "dashed",
    position: "absolute",
    width: "100%",
    color: "white",
    borderTop: "none",
    borderBottom: "none",
  },
}));
